export const MAX_LENGTH_COUPON = 12;
export const DEBOUNCE_INPUT_TIME = 250;
export const NAME_MAX_LENGTH = 256;
export const LAYOUT_NAME_MAX_LENGTH = 50;
export const CAPTURE_POSITION_TEMPLATE_MAX_LENGTH = 8;

export const CURRENCY_SYMBOL = 'đ';

export const STATUS_TYPES = {
  ALL: -1,
  ACTIVE: 1,
  INACTIVE: 0,
};

export const FALSE_TEXT = 'f';

export enum SORT_TYPES {
  ASC = 'asc',
  DESC = 'desc',
}

export enum MODULE_TYPES {
  PhotoAlbum = 'PhotoAlbum',
}

export const FEEDBACK_EVALUATION_CRITERIA_TYPE_RANKING = 1;
export const FEEDBACK_EVALUATION_CRITERIA_TYPE_QUESTION = 2;

export const PAGE_SIZE_IMAGES_RESOURCE = 12;
export const PAGE_SIZE_VIDEOS_RESOURCE = 9;
export const MEDIA_MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB in bytes
